// extracted by mini-css-extract-plugin
module.exports = {"preview":"territory-branding_preview__cPJde","previewImage":"territory-branding_previewImage__yg9xJ","colorInput":"territory-branding_colorInput__LkBLP"};